import ApiUtil from './api';

class PopupApi extends ApiUtil {
  getPopups() {
    return this.get('/api/v2/popups');
  }

  mark(popupId, type) {
    return this.post(`/api/v2/popups/${popupId}/mark-as-${type}`);
  }
}

export default new PopupApi();
